<tr [ngClass]="{'table-row-border': !(descriptionVisible && auditLog.content)}">
<td class="log-cell align-center">
  <fa-icon [icon]="auditLog | auditLogTitleHelper: 'icon'" style="margin-right: 16px; float: left;"></fa-icon>
  <label style="font-style: italic">{{auditLog.timestamp | commonDate}}</label>
</td>
<td class="log-cell">
    <p style="font-weight: bold"> {{auditLog.user || 'System'}}</p>
</td>
<td class="log-cell" *ngIf="!subject.length">
  <label>{{auditLog.subject}}</label>
</td>
<td class="log-cell" *ngIf="subject.length">
  <label>{{subject[0]}}
    <a class="a-link-no-underline" style="margin-left: 4px" (click)="navigate()" target="_blank">{{urlValue}}</a>
    {{subject[1]}}
  </label>
</td>
</tr>
<tr *ngIf="descriptionVisible && auditLog.content" class="table-row-border">
    <td></td>
    <td class="log-cell" colspan="3" *ngIf="descriptionVisible && auditLog.content">
        <pre *ngIf="auditLog.contentType === 'text/plain'" style="white-space: pre-line;" lang="text">{{auditLog.content}}</pre>
        <span *ngIf="!auditLog.contentType || auditLog.contentType === 'text/html'" [innerHTML]="auditLog.content"></span>
        <pre *ngIf="auditLog.contentType === 'application/xml'" lang="xml">{{auditLog.content}}</pre>
        <pre *ngIf="auditLog.contentType === 'application/json'" lang="json">{{auditLog.content}}</pre>
    </td>
</tr>
